import React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
import BusinessLogo from '../../../../../img/logos/business-logo.png';
import iaqInsight2PdfStyles from '../utils/pdfStyles';

const IaqInsight2Footer = (): React.ReactElement => {
    return (
        <View fixed style={iaqInsight2PdfStyles.footer}>
            <Text
                style={iaqInsight2PdfStyles.smallText}
                render={({ pageNumber, totalPages }: { pageNumber: number; totalPages: number }): string =>
                    `${pageNumber} / ${totalPages}`
                }
                fixed
            />
            <Image style={iaqInsight2PdfStyles.smallLogo} src={BusinessLogo} />
        </View>
    );
};

export default IaqInsight2Footer;
